export const ADMIN_URL_PATH = '/admin' as const;
export const SUBSCRIPTION_MANAGEMENT_URL_PATH =
  `${ADMIN_URL_PATH}//manage-credit-subscriptions` as const;
export const DATASOURCES_URL_PATH = '/datasources' as const;
export const DATASOURCE_URL_PATH =
  `${DATASOURCES_URL_PATH}/:datasourceId` as const;
export const DASHBOARDS_URL_PATH = `${DATASOURCE_URL_PATH}/dashboards` as const;
export const DASHBOARD_URL_PATH =
  `${DASHBOARDS_URL_PATH}/:dashboardId` as const;
export const GRANT_URL_PATH = '/grant' as const;
export const ACCESS_REVIEW_PATH = `${GRANT_URL_PATH}/:datasourceId` as const;
export const ACCESS_REQUEST_PATH =
  `${GRANT_URL_PATH}/request/:datasourceId` as const;
export const MAP_URL_PATH = `${DATASOURCE_URL_PATH}/map` as const;
export const SETTINGS_URL_PATH = `${DATASOURCE_URL_PATH}/settings` as const;
export const SETUP_URL_PATH = `${DATASOURCE_URL_PATH}/setup` as const;
export const CONFIGURE_TABLES_URL_PATH =
  `${DATASOURCE_URL_PATH}/configure/tables` as const;
export const CREDITS_URL_PATH = `${DATASOURCE_URL_PATH}/credits` as const;
export const TEAM_URL_PATH = `${DATASOURCE_URL_PATH}/team` as const;
export const BILLING_URL_PATH = `${DATASOURCE_URL_PATH}/billing` as const;
export const CANCEL_URL_PATH = `${BILLING_URL_PATH}/cancel` as const;
export const QUERY_BUILDER_URL_PATH =
  `${DATASOURCE_URL_PATH}/queries/:queryId/:dataPresentation?` as const;
export const QUERY_BUILDER_SAVED_QUERY_URL_PATH =
  `${DATASOURCE_URL_PATH}/saved-queries/:seriesId/:dataPresentation?` as const;
export const SAVED_QUERIES_URL_PATH =
  `${DATASOURCE_URL_PATH}/saved-queries` as const;
export const SETUP_DATABASE_URL_PATH = 'setup/:databaseType' as const;
export const SHARING_URL_PATH = '/share' as const;
export const SHARE_SAVED_QUERY_URL_PATH =
  `${SHARING_URL_PATH}/view/:sharableSeriesId/load.html` as const;
export const SHARE_DASHBOARD_URL_PATH =
  `${SHARING_URL_PATH}/dashboard/:dashboardId/load.html` as const;
export const REPORT_URL_PATH = `${DATASOURCE_URL_PATH}/reports` as const;
